import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amende-list',
  templateUrl: './amende-list.component.html',
  styleUrls: ['./amende-list.component.scss']
})
export class AmendeListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
